/**
 * Coerce form values for create/update API payloads.
 */
export const toBoolean = (value) => value === true || value === 'true';

export const toInteger = (value) => {
    if (value === null || value === undefined || value === '') {
        return null;
    }
    const parsed = Number(value);
    return Number.isNaN(parsed) ? null : parsed;
};

export const toIntFlag = (value) => (toBoolean(value) ? 1 : 0);
